import React from "react";
import { useDispatch, useSelector } from "react-redux";
import LoginForm from "../../components/header/LoginForm";
import RegisterForm from "../../components/header/RegisterForm";
import ResetForm from "../../components/header/ResetFrom";
import { setFormType } from "../../auth/authSlice";
import { TrainingCard } from "./TrainingCard";
import { useTrainingsQuery } from "../../hooks/queries/use-trainings-query";
import PrimaryButton from "../../UI/PrimaryButton";

const Trainings = () => {
  const { data: workoutCourses } = useTrainingsQuery();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const formType = useSelector((state) => state.auth.formType);
  const dispatch = useDispatch();

  const toggleForm = (type) => {
    dispatch(setFormType(type));
  };

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col items-center justify-center p-4 min-h-screen">
        {!formType && (
          <div className="bg-white shadow-lg rounded-xl p-8 max-w-md text-center">
            <h1 className="text-3xl font-extrabold text-baseBlue mb-4">
              Wellcome To Our Club!
            </h1>
            <p className="text-gray-600 mb-6">
              Sign in to unlock our premium training courses and take your arm
              wrestling skills to the next level. Your journey to greatness
              starts here!
            </p>

            <PrimaryButton
              text="LOG IN TO GET STARTED"
              onClick={() => toggleForm("login")}
            />
          </div>
        )}
        {formType === "login" && <LoginForm toggleForm={toggleForm} />}
        {formType === "register" && <RegisterForm toggleForm={toggleForm} />}
        {formType === "reset" && <ResetForm toggleForm={toggleForm} />}
      </div>
    );
  }

  return (
    <div className="px-6 py-12 min-h-screen mt-10 lg:mt-20">
      <h1 className="text-baseBlue text-2xl lg:text-4xl font-extrabold text-center mb-6 lg:nb-12">
        Arm Wrestling Online Courses
      </h1>

      <div className="flex flex-wrap justify-center gap-12">
        {workoutCourses?.map((course) => (
          <TrainingCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default Trainings;
